import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RelationshipTreeNode } from '../relationship-tree.view-model';

@Injectable({
    providedIn: 'root'
})
export class RemoveRelationshipDialogService {

    openDialog$: Subject<any> = new Subject();
    removeRelationship$: Subject<any> = new Subject();
    constructor() { }

    open(rootNode: RelationshipTreeNode, rootNodeName: string, relationshipTypeName: string,
        showName: string, isContactParent: boolean, isEntityRootNode: boolean, eventKey?: string, eventValue?: string): Subject<any> {
        if (showName) {
            this.openDialog$.next({
                type: 'removeOneRelationship',
                payload:
                {
                    rootNode: rootNode,
                    rootNodeName: rootNodeName,
                    relationshipTypeName: relationshipTypeName,
                    showName: showName,
                    isContactParent: isContactParent,
                    isEntityRootNode: isEntityRootNode,
                    eventKey: eventKey,
                    eventValue: eventValue
                }
            });
        } else {
            this.openDialog$.next({
                type: 'removeMultiRelationship',
                payload:
                {
                    rootNode: rootNode,
                    rootNodeName: rootNodeName,
                    relationshipTypeName: relationshipTypeName,
                    isContactParent: isContactParent,
                    isEntityRootNode: isEntityRootNode,
                    eventKey: eventKey,
                    eventValue: eventValue
                }
            });
        }
        return this.removeRelationship$;
    }
}
